import { render } from "./WidgetOrdersDaily.vue?vue&type=template&id=6ad85229&scoped=true&ts=true"
import script from "./WidgetOrdersDaily.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersDaily.vue?vue&type=script&lang=ts"

import "./WidgetOrdersDaily.vue?vue&type=style&index=0&id=6ad85229&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad85229"]])

export default __exports__